// extracted by mini-css-extract-plugin
export default {"tooltip":"zm-z","sharingV2":"Am-z","sharingIconsV2":"Bm-z","links":"Cm-z","link":"Dm-z","facebookV2":"Em-z","twitterV2":"Fm-z","pinterestV2":"Gm-z"};